// Build out our basic SafeString type
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
  return '' + this.string;
};

export default SafeString;



// WEBPACK FOOTER //
// ../../../lib/handlebars/safe-string.js